import home from '../api/home'

function shuffleArray(items) {
    for (let i = items.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * i)
        const temp = items[i]
        items[i] = items[j]
        items[j] = temp
    }
    return items;
}

function shuffleCluster(cluster, columns) {
    let items = [];
    let clusterTags = [];
    if (cluster.events) {
        items = items.concat(cluster.events);
    }

    //group labels and subcate into 2 clusters of max 3 items
    if (cluster.labels) {
        clusterTags = clusterTags.concat(cluster.labels
            .filter(item => {
                return item.name !== null && item.name !== ""
            })
            .map(item => {
                item.model = 'label';
                return item;
            }));
    }
    if (cluster.subcategories) {
        clusterTags = clusterTags.concat(cluster.subcategories
            .filter(item => {
                return item.name !== null && item.name !== ""
            })
            .map(item => {
                item.model = 'subcategory';
                return item;
            }));
    }


    if (clusterTags.length > 1) {
        clusterTags = shuffleArray(clusterTags);
        let tempTag = []
        for (let i = 0; i < clusterTags.length; i++) {
            tempTag.push(clusterTags[i]);
            if (tempTag.length === 6) {
                tempTag.model = 'clusterTag';
                items.push(tempTag);
                tempTag = []
            }
        }
        if (tempTag.length) {
            tempTag.model = 'clusterTag';
            items.push(tempTag);
        }
    }


    if (cluster.videos) {
        items = items.concat(cluster.videos.map(item => {
            item.model = 'video';
            return item;
        }));
    }
    items = shuffleArray(items);
    let currentColumn = 0;
    let currentRow = 1;

    let isProject = cluster.root.model === 'project' && cluster.root.slogan !== null;

    if (items.length >= 3) {
        for (const item of items) {
            currentColumn++;
            if (currentColumn > columns) {
                currentColumn = 1;
                currentRow++;
            }
            if (isProject && currentColumn === 2 && currentRow === 1) {
                //jump this position
                if (columns === 2) {
                    currentColumn = 1;
                    currentRow++;
                } else {
                    currentColumn++;
                }
            }
            if (currentColumn === 2 && currentRow === 2) {
                //jump this position
                if (columns === 2) {
                    currentColumn = 1;
                    currentRow++;
                } else {
                    currentColumn++;
                }
            }
            item.column = currentColumn;
            item.row = currentRow;
            /*item.offsetX = Math.floor(Math.random() * 199) - 99;
            item.offsetY = Math.floor(Math.random() * 199) - 99;*/
        }
    } else {
        currentColumn++;
        for (const item of items) {
            item.column = currentColumn;
            item.row = currentRow;
            currentColumn = columns;
        }
    }

    return items
}

const state = {
    // clusters indexed by page number
    clusters: {},
    firstCluster: {},
    sortedClusters: [],
    currentPage: 0,
    currentPaginationSize: 15,

    homeHeaderSection: {
        quote: '',
        background_color: '#000000',
        quote_color: '#ffffff',
        items: [],
        randomItems: []
    }
}

const getters = {
    sortedItems: state => {
        return state.homeHeaderSection.items.slice().sort((a, b) => a.position - b.position);
    },
    getAllClusters: state => {
        return Object.values(state.clusters).flat()
    },
    getAllSortedClusters: state => {
        return state.sortedClusters
    },
    getFirstCluster: state => {
        return state.firstCluster
    }
}

const actions = {
    searchClusters({state, commit, dispatch}, {
        page = 1,
        labels = [],
        subcategories = [],
        paginationSize = 15,
        columns = 3
    }) {
        commit('setCurrentPaginationSize', paginationSize)

        commit('ui/enableLoader', 'SEARCH_CLUSTERS_PAGE_' + page, {root: true})

        if (state.clusters[page]) {
            commit('ui/disableLoader', 'SEARCH_CLUSTERS_PAGE_' + page, {root: true})
            return state.clusters[page]
        }

        return home.searchClusters(page, labels, subcategories, paginationSize).then(response => {
            const clusters = Array.isArray(response.data) ? response.data : Object.values(response.data)
            commit('setClustersForPage', {page: page, clusters: clusters})
            return clusters
        }, () => false).finally(() => {
            commit('shuffleClusterItems', columns)
            commit('ui/disableLoader', 'SEARCH_CLUSTERS_PAGE_' + page, {root: true})
        })
    },

    getHomeHeaderSection({commit, dispatch}) {
        commit('ui/enableLoader', 'GET_HOME_EVENTS', {root: true})
        return home.getHomeHeaderSection().then(response => {
            commit('setHomeHeaderSection', response.data)

            //dispatch('file/getAllFilesThumbnails', items.filter(item => item.cover && item.cover.file).map(item => item.cover.file.id), {root: true})

            commit('shuffleHomeItems')

            return response.data
        }, () => false).finally(() => commit('ui/disableLoader', 'GET_HOME_EVENTS', {root: true}))
    }
}

const mutations = {
    setFirstCluster(state, {cluster, columns}) {
        state.firstCLuster = shuffleCluster(cluster, columns)
    },
    setClustersForPage(state, {page, clusters}) {
        state.clusters = {
            ...state.clusters,
            [page]: clusters
        }
        state.currentPage = page
    },
    setCurrentPaginationSize(state, paginationSize) {
        if (state.currentPaginationSize != paginationSize) {
            state.clusters = {}
            state.currentPaginationSize = paginationSize
        }
    },
    setHomeHeaderSection(state, section) {
        state.homeHeaderSection = section
    },
    shuffleHomeItems(state) {

        let items = state.homeHeaderSection.items;
        //loop to define opacity and size
        /*let opacity = 1;
        let size = 100;
        for (const item of items) {
            item.opacity = opacity;
            opacity -= 0.15;
            item.size = size;
            size -= 5;
            item.offsetY = Math.floor(Math.random() * Math.floor(3));
            item.offsetX = Math.floor(Math.random() * Math.floor(3));
        }

        //prepare for random position
        for (let i = items.length; i < 8; i++) {
            items.push(null);
        }*/
        state.homeHeaderSection.randomItems = shuffleArray(items);
    },
    shuffleClusterItems(state, columns) {
        let clusters = Object.values(state.clusters[state.currentPage]);


        if (state.currentPage === 1) {
            let first = clusters.shift()
            first.sorted = shuffleCluster(first, columns)
            state.firstCluster = first
        }

        clusters.map(cluster => {
            cluster.sorted = shuffleCluster(cluster, columns)
        })
        state.sortedClusters = state.sortedClusters.concat(clusters)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
